<template>
  <div class="workbench">
    <WorkbenchTopBar />
    <div class="workbench-body">
      <WorkbenchLeftPanel />
      <WorkbenchAuthorEdit v-if="store.editingPane.value === 'author'" />
      <WorkbenchProjectEdit v-else-if="store.editingPane.value === 'project'" />
      <WorkbenchMain v-else />
    </div>
    <RightRollout />

    <!-- Backdrop for left drawer (mobile only) -->
    <Transition name="fade">
      <div
        v-if="store.leftDrawerOpen.value"
        class="md:hidden fixed inset-0 bg-black/30 z-30"
        @click="store.leftDrawerOpen.value = false"
      />
    </Transition>

    <!-- Backdrop for right drawer (mobile only) -->
    <Transition name="fade">
      <div
        v-if="store.rightDrawerOpen.value"
        class="md:hidden fixed inset-0 bg-black/30 z-30"
        @click="store.rightDrawerOpen.value = false"
      />
    </Transition>
  </div>
</template>

<script setup>
import { provide, onMounted } from 'vue'
import { useWorkbenchStore } from '../../composables/useWorkbenchStore'
import WorkbenchTopBar from './WorkbenchTopBar.vue'
import WorkbenchLeftPanel from './WorkbenchLeftPanel.vue'
import WorkbenchMain from './WorkbenchMain.vue'
import WorkbenchAuthorEdit from './WorkbenchAuthorEdit.vue'
import WorkbenchProjectEdit from './WorkbenchProjectEdit.vue'
import RightRollout from './RightRollout.vue'

const props = defineProps({
  csrfToken: String,
})

const store = useWorkbenchStore(props.csrfToken)
provide('workbench', store)

onMounted(async () => {
  await store.loadProjects()
  store.loadAllAuthors()
  store.loadCmsConnections()
  const savedProjectId = localStorage.getItem('workbench:projectId')
  if (savedProjectId) {
    const id = Number(savedProjectId)
    if (store.projects.value.some(p => p.id === id)) {
      await store.selectProject(id)
    }
  }
})
</script>

<style scoped>
.workbench {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
}

.workbench-body {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
